class MenuPanels extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.toggle.elements.forEach(toggle => {
      this.listeners.add(toggle, 'click', () => {
        this.openMenu(toggle.dataset.menuId)
      })
    })
  }

  /** @param {string} id */
  openMenu (id) {
    const attribute = 'active'

    this.els.menu.elements.forEach(menu => {
      const isTargetMenu = menu.dataset.menuId === id
      const menuPanel = this.els.panel.elements.find(panel =>
        menu.contains(panel),
      )

      if (isTargetMenu) {
        menu.setAttribute(attribute, '')
      } else {
        menu.removeAttribute(attribute)
      }

      menuPanel.setAttribute('aria-hidden', !isTargetMenu)
    })
  }
}

if (!customElements.get('menu-panels')) {
  customElements.define('menu-panels', MenuPanels)
}
